// extracted by mini-css-extract-plugin
module.exports = {"uploadtest":"BBUpload_uploadtest__2XYYP","upload1":"BBUpload_upload1__2qlqt","text":"BBUpload_text__198fb","tips":"BBUpload_tips__1CuvP","upload2":"BBUpload_upload2__1L0yD"};